import { Reducer } from 'redux';
import { IResetPasswordActionTypes, IResetPasswordState } from './Types';

const initialState: IResetPasswordState = {
	email: '',
	username: '',
	resetIsError: '',
	resetIsSucceed: false,
	recoveredUsernameIsError: '',
	recoveredUsernameIsSuceed: false,
	recoveredUsernameIsMultiple: false,
};

const reducer: Reducer<IResetPasswordState> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case IResetPasswordActionTypes.SEND_RESET_PASSWORD_EMAIL_FAILED: {
			return {
				...state,
				resetIsError: action.payload,
				resetIsSucceed: false,
			};
		}

		case IResetPasswordActionTypes.SEND_RESET_PASSWORD_EMAIL_SUCCEED: {
			return {
				...state,
				resetIsError: '',
				resetIsSucceed: true,
			};
		}

		case IResetPasswordActionTypes.RECOVER_USERNAME_FROM_EMAIL_FAILED: {
			return {
				...state,
				recoveredUsernameIsError: action.payload,
				recoveredUsernameIsSuceed: false,
			};
		}

		case IResetPasswordActionTypes.RECOVER_USERNAME_FROM_EMAIL_SUCCEED: {
			return {
				...state,
				recoveredUsernameIsError: action.payload,
				recoveredUsernameIsSuceed: false,
			};
		}

		case IResetPasswordActionTypes.RECOVERED_SINGLE_USERNAME: {
			return {
				...state,
				username: action.payload,
				recoveredUsernameIsMultiple: false,
			};
		}

		case IResetPasswordActionTypes.RECOVERED_MULTIPLE_USERNAME: {
			return {
				...state,
				recoveredUsernameIsMultiple: true,
			};
		}
		default: {
			return state;
		}
	}
};

export { reducer as ResetPasswordReducer };
